/*
 * The copyright line, used at the bottom of the home page, in the About /
 * Contact panel and on each release page (each place styles it with its own
 * className). The year updates itself.
 */
function Copyright({ className = "" }) {
  return (
    <p className={className}>
      © {new Date().getFullYear()} thangcao
      <span aria-hidden="true"> · </span>
      made by thangcao
    </p>
  );
}

export default Copyright;
